module.exports = "/_next/static/images/65c0be1541eacd456e5894420451f9cb-women-lg.png";